import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useNavigate } from '@/libs/router'
import { useWorkflows } from '@/features/workflows/hooks/use-workflows'

const TasksIndex = () => {
	const { workflows } = useWorkflows()
	const navigate = useNavigate()

	useEffect(() => {
		const first = workflows[0]
		if (first) {
			navigate({ to: '/tasks/$workflow-id', params: { 'workflow-id': first.id }, replace: true })
		}
	}, [workflows, navigate])

	return null
}

export const Route = createFileRoute('/_authenticated/tasks/')({
	component: TasksIndex,
})
